import { Component, forwardRef, Input, ChangeDetectionStrategy } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from "@angular/forms";

@Component({
    selector: 'rl-color-picker-input',
    templateUrl: './color-picker-input.component.html',
    styleUrls: ['./color-picker-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ColorPickerInputComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, FormsModule]
})
export class ColorPickerInputComponent implements ControlValueAccessor {

	@Input()
	disabled: boolean = false;

	@Input()
	placeholder = '#000000';

	value: string;

	onChange = (value: string) => {};
	onTouched = () => {};

	constructor() { }

	writeValue(hexValue: string): void {
		this.value = hexValue;
		this.emitChange();
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
	
	emitChange() {
		this.onChange(this.value);
	}

}